import * as Highcharts from 'highcharts';
import HC_more from 'highcharts/highcharts-more';
import HC_exportData from 'highcharts/modules/export-data';
import HC_exporting from 'highcharts/modules/exporting';
import HC_heatmap from 'highcharts/modules/heatmap';
import HC_offlineExporting from 'highcharts/modules/offline-exporting';

// Register Highcharts modules on the shared singleton once (idempotent). The
// export modules power Chart/Matrix CSV + PNG download; heatmap powers Matrix.
// `exportChartLocal`/`downloadCSV` run fully client-side — no chart data is sent
// to Highcharts' export servers. Order matters: export-data depends on exporting.
// highcharts-more provides the bubble series type (scatter is core).
[HC_exporting, HC_exportData, HC_offlineExporting, HC_heatmap, HC_more].forEach((register) => (register as (h: typeof Highcharts) => void)(Highcharts));

// useToken returns CSS var refs for semantic tokens, and Chakra semantic tokens
// often chain (primary.bg → var(--…-blue-500) → hex). CSS vars don't resolve
// during offline PNG rasterization and can't be interpolated (the heatmap color
// gradient), so resolve the whole chain to its leaf hex up front. Depth-capped.
export function resolveCssColor(color: string, depth = 0): string {
	const match = /^var\((--[^,)\s]+)/.exec(color.trim());
	if (!match || typeof document === 'undefined' || depth > 5) return color;
	const resolved = getComputedStyle(document.documentElement).getPropertyValue(match[1]).trim();
	if (!resolved) return color;
	return resolveCssColor(resolved, depth + 1);
}

export { Highcharts };
